export const arrayMoveMutable = (array: any[], from: number, to: number) => {
  const item = array.splice(from, 1)[0];
  array.splice(to, 0, item);
  return array;
};

export const arrayMoveImmutable = (array: any[], from: number, to: number) => {
  const newArr = [...array];
  const item = newArr.splice(from, 1)[0];
  newArr.splice(to, 0, item);
  return newArr;
};
